export default __webpack_public_path__ + "static/media/jblfone.6503e57a.png";